const TRIGGERS = {
  textReveal: function(el) {
    let start = el.getAttribute('data-start') || 'top bottom'
    let markers = (el.getAttribute('data-markers')=="" || el.getAttribute('data-markers')=="true" ) || false

    gsap.effects.textReveal(el, {
      delay: el.getAttribute('data-delay') || 0,
      scrollTrigger: {
        trigger: el,
        toggleActions: "play none none reverse",
        start: start,
        markers: markers,
      },
    })
    
    // if (!Array.isArray(el)) {
    //   SplitText.create(el, {
    //     type: 'lines',
    //     autoSplit: true,
    //     onSplit(self) {
    //       return gsap.effects.textReveal(self.lines, {
    //         delay: el.getAttribute('data-delay'),
    //         scrollTrigger: {
    //           trigger: el,
    //           toggleActions: "play none none reverse",
    //           start: start,
    //           markers: markers,
    //         },
    //       })
    //     },
    //   })
    // }
  },

  imageReveal: function(el) {
    let start = el.getAttribute('data-start') || 'top bottom'
    let markers = (el.getAttribute('data-markers')=="" || el.getAttribute('data-markers')=="true" ) || false

    gsap.effects.imageReveal(el, {
      delay: el.getAttribute('data-delay'),
      scrollTrigger: {
        trigger: el,
        toggleActions: "play none none reverse",
        start: start,
        markers: markers,
      }
    })
  },

  parallax: function(el) {
    let start = el.getAttribute('data-start') || 'top bottom'
    let end = el.getAttribute('data-start') || 'bottom top'
    let markers = (el.getAttribute('data-markers')=="" || el.getAttribute('data-markers')=="true" ) || false

    return gsap.effects.parallax(el, {
      scrollTrigger: {
        trigger: '.'+[...el.parentNode.classList].join('.'),
        toggleActions: 'play none none reverse',
        start: start,
        end: end,
        scrub: true,
        markers: markers,
      }
    })
  },
  
  phraseReveal: function(el) {
    SplitText.create(el, {
      type: 'chars',
      autoSplit: true,
      onSplit(self) {
        console.log(self);
        
        return gsap.fromTo(self.chars, {
          opacity: 0.4,
        }, {
          opacity: 1,
          delay: el.getAttribute('data-delay'),
          stagger: .03,
          duration: .6,
          scrollTrigger: {
            trigger: el,
            toggleActions: "play none none reverse",
            start: 'top bottom-=10%',
            // markers: true,
          },
        })
      },
    })
  },
}